import { render } from "./property-saleproceeds.vue?vue&type=template&id=38665247"
import script from "./property-saleproceeds.js?vue&type=script&lang=js"
export * from "./property-saleproceeds.js?vue&type=script&lang=js"

import "./property-saleproceeds.vue?vue&type=style&index=0&id=38665247&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__